import React, { createRef, useState } from 'react';
import { ViewSnapshotContext, type ViewSnapshotRegistry } from './viewSnapshotContext';

/** Scopes screenshots to one screen: its root, and the views inside it that draw themselves. */
const ViewSnapshotProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [registry] = useState<ViewSnapshotRegistry>(() => ({
    rootRef: createRef<HTMLDivElement>(),
    sources: new Set(),
  }));
  return <ViewSnapshotContext.Provider value={registry}>{children}</ViewSnapshotContext.Provider>;
};

export default ViewSnapshotProvider;
